import m from "../../geodata/es2015/andorraLow";
window.am4geodata_andorraLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/andorraLow.js
// module id = null
// module chunks = 